import * as React from 'react';
import {  useContext } from "react";
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
	ChevronLeftIcon,
	ChevronRighttIcon,
} from '../../../styles/images/svg/ChevronIcons';

import {
	DashboardIcon,
	LocationIcon,
	ParticipantsIcon,
	HomeContentIcon,
	IncentivesIcon,
	CommunicationsIcon,
	KnowledgeIcon,
	DataManagementIcon,
} from '../../../styles/images/svg/DashboardIcons';
import { SidebarMenu } from './SidebarMenu';
import {Context} from "../../../_context/Store";


const drawerWidth = 300;

const openedMixin = (theme) => ({
	width: drawerWidth,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
});

const closedMixin = (theme) => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	padding: theme.spacing(0),
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
	shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
	width: drawerWidth,
	flexShrink: 0,
	whiteSpace: 'nowrap',
	boxSizing: 'border-box',
	...(open && {
		...openedMixin(theme),
		'& .MuiDrawer-paper': openedMixin(theme),
	}),
	...(!open && {
		...closedMixin(theme),
		'& .MuiDrawer-paper': closedMixin(theme),
	}),
}));

export default function Sidebar(props) {
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);

    const [state, dispatch] = useContext(Context);

	const handleClick = () => {
		setOpen(!open);
		if(open === true){
			dispatch({ type: "SIDEBAR_TOGGLE", payload: false });
		}
		else{
			dispatch({ type: "SIDEBAR_TOGGLE", payload: true });
		}
		
	};

	return (
		<>
			<Drawer variant="permanent" 
				open={open} className="sbt-dashboard-drawer">
				<DrawerHeader>
					<IconButton
						onClick={handleClick}
						sx={{
							display: 'flex',
							width: '40px',
    						height: '40px',
							justifyContent:'center',
							mt:'5px',
							ml:'5px',
							justifyContent: open ? 'flex-start' : 'flex-end',
							marginRight: open ? 'auto' : '5px',
						}}
					>
						<span className="sba-drawer-toggle-ic1n">
							{open ? <ChevronLeftIcon /> : <ChevronRighttIcon />}
						</span>
					</IconButton>
				</DrawerHeader>
				<List className="sbt-dashboard-sidebar">
					<SidebarMenu open={open} />
				</List>
			</Drawer>
		</>
	);
}
